export default {
    apiPath: 'http://2018.atwinta.ru/api/',
    basePath: 'http://2018.atwinta.ru/',
    basename: '/'
}


// WEBPACK FOOTER //
// ./src/config/prod.js